export default "__VITE_ASSET__D6p3HGvW__"